import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_VACATIONS_ENJOY_REQUEST = "GET_VACATIONS_ENJOY_REQUEST";
export const GET_VACATIONS_ENJOY_SUCCESS = "GET_VACATIONS_ENJOY_SUCCESS";
export const GET_VACATIONS_ENJOY_ERROR = "GET_VACATIONS_ENJOY_ERROR";

//* ACTIONS ------------------------------------------------
export const getVacationsEnjoyRequest = (payload = {}, callback) => ({
  type: GET_VACATIONS_ENJOY_REQUEST,
  payload,
  callback,
});

export const getVacationsEnjoySuccess = (data) => ({
  type: GET_VACATIONS_ENJOY_SUCCESS,
  payload: data,
});

export const getVacationsEnjoyError = (error) => ({
  type: GET_VACATIONS_ENJOY_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getVacationsEnjoyServiceRequest = async ({ ...params }) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/vacations/enjoy_vacation`, options);
};
